/**
 * VDSL line error-health chip — the VDSL counterpart of the GPON RX pill.
 * Renders nothing for good / unknown / never-evaluated ports; warning is
 * amber, critical red. The tooltip lists the 7-day totals and the
 * thresholds that tripped (``vdsl_inventory.errors_7d``).
 */
import { Badge } from "./Badge";
import {
  isVdslErrorFlagged,
  vdslErrorLabel,
  vdslErrorTone,
  vdslErrorTooltip,
  type VdslErrors7d,
} from "../lib/signalTones";

export function VdslErrorChip({
  health,
  errors,
}: {
  health: string | null | undefined;
  errors: VdslErrors7d | null | undefined;
}) {
  if (!isVdslErrorFlagged(health)) return null;
  return (
    <Badge tone={vdslErrorTone(health)} title={vdslErrorTooltip(health, errors)}>
      ⚠ {vdslErrorLabel(health)}
    </Badge>
  );
}
